import Breadcrumb from "@/components/base/Breadcrumb";
import { useNavigate } from "react-router-dom";

export default function MasterBindTab() {
  const navigate = useNavigate();

  return (
    <div className="space-y-5 max-w-[760px]">
      <Breadcrumb items={[{ label: "管理后台", href: "/forex/overview" }, { label: "主账号管理", href: "/forex/master" }, { label: "主账号绑定" }]} />
      <div className="bg-white rounded-lg border border-surface-border p-6">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-lg bg-primary-500/10 text-primary-500 flex items-center justify-center shrink-0">
            <i className="ri-link-m text-lg" />
          </div>
          <div className="min-w-0 flex-1">
            <h2 className="text-lg font-semibold text-text-primary">主账号绑定入口已统一</h2>
            <p className="text-xs text-text-muted mt-1 leading-relaxed">
              主账号绑定只保留一个真实流程：填写账号信息、验证账号、确认绑定，最终调用
              <span className="font-mono text-primary-500 mx-1">POST /quantum/business/forex/master-accounts</span>
              创建主账号。旧 Tab 不再保留本地验证或本地提交状态。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <button onClick={() => navigate("/forex/master-accounts/bind")} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line text-sm" />进入主账号绑定流程
              </button>
              <button onClick={() => navigate("/forex/master-accounts")} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-medium bg-surface text-text-secondary hover:bg-brand/10 hover:text-brand transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-list-check-2 text-sm" />查看主账号列表
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
